export const MAX_OFFICIATING_MINISTERS = 5;

export interface WitnessDraft {
  memberId: string | null;
  name: string;
}

export interface MinisterDraft {
  key: string;
  name: string;
}

export const emptyWitnessPair = (): [WitnessDraft, WitnessDraft] => [
  { memberId: null, name: '' },
  { memberId: null, name: '' },
];

export const witnessDraftsFrom = (
  witnesses: Array<{ memberId?: string | null; name?: string | null }> | null | undefined,
): [WitnessDraft, WitnessDraft] => [
  { memberId: witnesses?.[0]?.memberId ?? null, name: witnesses?.[0]?.name ?? '' },
  { memberId: witnesses?.[1]?.memberId ?? null, name: witnesses?.[1]?.name ?? '' },
];

export const emptyMinister = (): MinisterDraft => ({
  key: crypto.randomUUID(),
  name: '',
});

export const ministerDraftsFrom = (names: string[]): MinisterDraft[] => {
  const rows = names
    .map((name) => name.trim())
    .filter(Boolean)
    .map((name) => ({ key: crypto.randomUUID(), name }));
  return rows.length > 0 ? rows : [emptyMinister()];
};
